$(function () {
  if (
    $(".new-pdp-box-footer-price").length > 0 &&
    $(".new-box-discount").length > 0
  ) {
    let disc = $(".new-box-discount.active").attr(
      "data-discount"
    );

    $(".new-pdp-box-footer-price").attr(
      "data-discount",
      disc
    );

    if ($(".new-pdp-box-footer-price dl").length > 0) {
      $(".new-pdp-box-footer-price dl").text(
        `${disc}% Discount`
      );
    }
  }
});

$(document).on(
  "click",
  ".new-box-discount",
  function () {
    $(".new-box-discount").removeClass("active");
    $(this).addClass("active");
  }
);

function updateActiveDiscount(quantity) {
  var disc = 0;
  var $discounts = $(".new-box-discount");

  var $sorted = $discounts.sort(function (a, b) {
    return $(a).data("count") - $(b).data("count");
  });

  $discounts.removeClass("active");

  var $matchedTier = null;

  $sorted.each(function () {
    var $tier = $(this);
    var count = parseInt($tier.data("count"), 10);

    if (quantity >= count) {
      $matchedTier = $tier;
    }
  });

  if (!$matchedTier && $sorted.length) {
    $matchedTier = $sorted.first();
  }

  if (!$matchedTier || !$matchedTier.length) {
    return 0;
  }

  $matchedTier.addClass("active");

  disc =
    parseInt(
      $matchedTier.attr("data-discount"),
      10
    ) || 0;

  if ($(".new-pdp-box-footer-price").length > 0) {
    $(".new-pdp-box-footer-price").attr(
      "data-discount",
      $matchedTier.attr("data-discount")
    );
  }

  if ($(".new-pdp-box-footer-price dl").length > 0) {
    var firstTierCount =
      parseInt(
        $discounts
          .eq(0)
          .attr("data-count"),
        10
      ) || 0;

    if (quantity >= firstTierCount) {
      $(".new-pdp-box-footer-price dl").show();
    } else {
      $(".new-pdp-box-footer-price dl").hide();
    }

    $(".new-pdp-box-footer-price dl").text(
      disc + "% Discount"
    );
  }

  return disc;
}

$(document).on(
  "click",
  ".new-pdp-prod-btn",
  function () {
    var $card = $(this).parents(
      ".new-pdp-prod-card"
    );

    var quantityInput = $card.find(
      ".new-pdp-prod-qty"
    )[0];

    $card.addClass("active");

    if (quantityInput) {
      quantityInput.stepUp(1);
    }

    updateBoxContent();
  }
);

$(document).on(
  "click",
  ".new-pdp-prod-qty-btn--plus",
  function () {
    var quantityInput = $(this)
      .parent()
      .find(".new-pdp-prod-qty")[0];

    if (quantityInput) {
      quantityInput.stepUp(1);
    }

    updateBoxContent();
  }
);

$(document).on(
  "click",
  ".new-pdp-prod-qty-btn--minus",
  function () {
    var $card = $(this).parents(
      ".new-pdp-prod-card"
    );

    var quantityInput = $(this)
      .parent()
      .find(".new-pdp-prod-qty")[0];

    if (quantityInput) {
      quantityInput.stepDown(1);

      if (
        parseInt(quantityInput.value, 10) <= 0
      ) {
        $card.removeClass("active");
      }
    }

    updateBoxContent();
  }
);

$(document).on(
  "click",
  ".new-pdp-box-content-close",
  function () {
    var productId = $(this).attr("data-id");

    var $quantityInput = $(
      `.new-pdp-prod-qty[data-id="${productId}"]`
    );

    $quantityInput.val(0);

    $quantityInput
      .parents(".new-pdp-prod-card")
      .removeClass("active");

    updateBoxContent();
  }
);

$(document).on(
  "click",
  ".new-pdp-box-header",
  function () {
    $(this).toggleClass("active");

    $(this)
      .parents(".new-pdp-box-wrapper")
      .find(".new-pdp-box-content-wrapper")
      .toggleClass("active");
  }
);

$(document).on(
  "change",
  ".new-pdp-box-footer-selling-plan-select",
  function () {
    $(".new-pdp-box-footer-btn").attr(
      "data-selling-plan",
      $(this).val()
    );

    var matchingMobileInput = document.querySelector(
      `.new-pdp-mobile-sp-inp[value="${$(this).val()}"]`
    );

    if (matchingMobileInput) {
      matchingMobileInput.checked = true;
    }
  }
);

/*
 * Existing Shopify cart meal quantity.
 * The mandatory Freeze Pack is excluded.
 */
let momExistingCartMealCount = 0;
let momExistingCartCountTimer = null;

const MOM_BOX_ITEM_PROPERTY = "_mom_box_item";
const MOM_FREEZE_VARIANT_ID = 40914461425700;

const MOM_BUILDER_PATHS = [
  "/products/60-pack",
  "/products/60-pack-nation-wide"
];

function getMomBuilderPath() {
  return (
    window.location.pathname.replace(/\/+$/, "") ||
    "/"
  );
}

function isMomBuilderPage() {
  return MOM_BUILDER_PATHS.indexOf(
    getMomBuilderPath()
  ) !== -1;
}

function isMomBoxCartItem(item) {
  return Boolean(
    item &&
      Number(item.variant_id) !==
        MOM_FREEZE_VARIANT_ID &&
      !item.gift_card &&
      item.properties &&
      String(
        item.properties[MOM_BOX_ITEM_PROPERTY]
      ) === "true"
  );
}

/*
 * When a customer enters either builder:
 *
 * - Preserve an existing marked meal-box cart.
 * - Clear normal products, gift cards or mixed carts.
 * - Clear an orphaned Freeze Pack.
 */
async function clearNonBuilderCartOnBuilderEntry() {
  if (!isMomBuilderPage()) {
    return false;
  }

  const response = await fetch("/cart.js", {
    method: "GET",
    credentials: "same-origin",
    headers: {
      Accept: "application/json"
    },
    cache: "no-store"
  });

  if (!response.ok) {
    throw new Error(
      "Builder cart check failed: " +
        response.status
    );
  }

  const cart = await response.json();

  const items = Array.isArray(cart.items)
    ? cart.items
    : [];

  if (!items.length) {
    return false;
  }

  const hasBoxMeals = items.some(
    isMomBoxCartItem
  );

  const hasOutsideItem = items.some(
    function (item) {
      const isFreezePack =
        Number(item.variant_id) ===
        MOM_FREEZE_VARIANT_ID;

      return (
        !isFreezePack &&
        !isMomBoxCartItem(item)
      );
    }
  );

  const hasOrphanFreezePack =
    !hasBoxMeals &&
    items.some(function (item) {
      return (
        Number(item.variant_id) ===
        MOM_FREEZE_VARIANT_ID
      );
    });

  /*
   * A valid existing builder cart can remain.
   */
  if (
    !hasOutsideItem &&
    !hasOrphanFreezePack
  ) {
    return false;
  }

  const clearResponse = await fetch(
    "/cart/clear.js",
    {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({})
    }
  );

  if (!clearResponse.ok) {
    throw new Error(
      "Builder cart clear failed: " +
        clearResponse.status
    );
  }

  /*
   * Refresh once so Liquid cart counts and drawer
   * content also display an empty cart.
   */
  window.location.reload();

  return true;
}

async function refreshMomExistingCartMealCount() {
  try {
    const response = await fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      },
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error(
        "Cart count request failed: " +
          response.status
      );
    }

    const cart = await response.json();

    momExistingCartMealCount = Array.isArray(
      cart.items
    )
      ? cart.items.reduce(function (
          count,
          item
        ) {
          if (!isMomBoxCartItem(item)) {
            return count;
          }

          return (
            count +
            Number(item.quantity || 0)
          );
        },
        0)
      : 0;

    /*
     * Recalculate the builder using the refreshed
     * existing-cart quantity.
     */
    if ($(".new-pdp-wrapper").length) {
      updateBoxContent();
    }
  } catch (error) {
    console.warn(
      "[MOM] Existing cart meal count failed:",
      error
    );
  }
}

function scheduleMomExistingCartMealRefresh() {
  clearTimeout(momExistingCartCountTimer);

  momExistingCartCountTimer = setTimeout(
    refreshMomExistingCartMealCount,
    150
  );
}

/*
 * Prepare the builder when its page opens.
 */
$(async function () {
  if (
    isMomBuilderPage() &&
    $(".new-pdp-wrapper").length
  ) {
    try {
      const cartWasCleared =
        await clearNonBuilderCartOnBuilderEntry();

      if (cartWasCleared) {
        return;
      }

      await refreshMomExistingCartMealCount();
    } catch (error) {
      console.error(
        "[MOM] Builder entry reset failed:",
        error
      );

      return;
    }
  }

  /*
   * Re-read the cart after Shopify replaces the
   * drawer HTML.
   */
  const cartDrawer =
    document.querySelector("cart-drawer");

  if (
    cartDrawer &&
    isMomBuilderPage()
  ) {
    const momCartDrawerObserver =
      new MutationObserver(function () {
        scheduleMomExistingCartMealRefresh();
      });

    momCartDrawerObserver.observe(
      cartDrawer,
      {
        childList: true,
        subtree: true
      }
    );
  }
});

function updateBoxContent() {
  /*
   * This function only belongs to the two meal
   * builder pages.
   */
  if (
    !isMomBuilderPage() ||
    !$(".new-pdp-wrapper").length
  ) {
    return;
  }

  let totalCount = 0;

  let totalPrice =
    parseFloat(
      $(".new-pdp-box-footer-price").attr(
        "data-price"
      )
    ) || 0;

  let moneyFormat =
    $(".new-pdp-box-footer-price").attr(
      "data-money"
    ) || "${{amount}}";

  let discount =
    parseInt(
      $(".new-pdp-box-footer-price").attr(
        "data-discount"
      ),
      10
    ) || 0;

  $(".new-pdp-box-content-wrapper").empty();

  $(".new-pdp-prod-card.active").each(
    function () {
      let quantity =
        parseInt(
          $(this)
            .find(".new-pdp-prod-qty")
            .val(),
          10
        ) || 0;

      if (quantity <= 0) {
        $(this).removeClass("active");
        return;
      }

      let unitPrice =
        parseFloat(
          $(this)
            .find(".new-pdp-prod-qty")
            .attr("data-price")
        ) || 0;

      let price = quantity * unitPrice;

      let productId = $(this).attr(
        "data-id"
      );

      let image = $(this)
        .find(".new-pdp-prod-card-img")
        .attr("data-img");

      let title = $(this)
        .find(".new-pdp-prod-card-title")
        .text();

      let content = `
        <div
          class="new-pdp-box-content-item"
          data-id="${productId}"
        >
          <span
            class="new-pdp-box-content-close"
            data-id="${$(this)
              .find(".new-pdp-prod-qty")
              .attr("data-id")}"
          >
            &#10005;
          </span>

          <img
            src="${image}"
            class="new-pdp-box-content-img"
            alt=""
          >

          <p class="new-pdp-box-content-title">
            ${title}

            <span>x ${quantity}</span>

            <span class="new-pdp-box-content-price">
              ${Shopify.formatMoney(
                price,
                moneyFormat
              )}
            </span>
          </p>
        </div>
      `;

      $(".new-pdp-box-content-wrapper").append(
        content
      );

      totalCount += quantity;
      totalPrice += price;
    }
  );

  $(".new-pdp-box-items-count").text(
    totalCount
  );

  /*
   * The discount tier uses the complete order:
   *
   * existing cart meals + newly selected meals.
   */
  let combinedMealCount =
    momExistingCartMealCount + totalCount;

  discount = updateActiveDiscount(
    combinedMealCount
  );

  if (discount > 0) {
    let discountAmount =
      totalPrice * (discount / 100);

    let finalPrice =
      totalPrice - discountAmount;

    $(".new-pdp-box-footer-price strike").text(
      Shopify.formatMoney(
        totalPrice,
        moneyFormat
      )
    );

    $(".new-pdp-box-footer-price em").text(
      Shopify.formatMoney(
        finalPrice,
        moneyFormat
      )
    );

    $(".new-pdp-box-footer-price dd").text(
      Shopify.formatMoney(
        discountAmount,
        moneyFormat
      )
    );
  } else {
    $(".new-pdp-box-footer-price em").text(
      Shopify.formatMoney(
        totalPrice,
        moneyFormat
      )
    );
  }

  /*
   * The first configured tier supplies the dynamic
   * minimum. It can therefore be 10 for Local and
   * 15 for Nationwide.
   */
  let requiredCount =
    parseInt(
      $(".new-box-discount")
        .first()
        .attr("data-count"),
      10
    ) || 0;

  /*
   * Require at least one new selected meal.
   * Existing meals plus new meals must meet the
   * configured minimum.
   */
  let canProceed =
    totalCount > 0 &&
    combinedMealCount >= requiredCount;

  if (canProceed) {
    $(".new-pdp-box-footer-btn")
      .addClass("active")
      .prop("disabled", false);
  } else {
    $(".new-pdp-box-footer-btn")
      .removeClass("active")
      .prop("disabled", true);
  }
}

function resetBoxContent() {
  $(".new-pdp-box-content-wrapper").empty();

  $(
    ".new-pdp-prod-qty:not(.new-pdp-prod-qty--chef)"
  ).val(0);

  $(".new-pdp-prod-card")
    .removeClass("active")
    .removeClass("disabled");
}

$(document).on(
  "change",
  ".new-pdp-box-choice-input",
  function () {
    resetBoxContent();

    if ($(this).val() === "chef-choice") {
      $(
        ".new-pdp-products-wrapper--chef .new-pdp-prod-card"
      ).addClass("active");
    }

    updateBoxContent();

    if ($(this).val() === "chef-choice") {
      $(".new-pdp-box-content-close").remove();
    }
  }
);

/*
 * Add selected builder meals to Shopify.
 */
$(document).on(
  "click",
  ".new-pdp-box-footer-btn.active",
  async function (event) {
    event.preventDefault();

    if (!isMomBuilderPage()) {
      return;
    }

    let $this = $(this);
    let arr = [];

    if ($this.hasClass("active-loading")) {
      return;
    }

    $this.addClass("active-loading");

    let sellingPlan =
      $this.attr("data-selling-plan");

    $(".new-pdp-prod-card.active").each(
      function () {
        let quantity =
          parseInt(
            $(this)
              .find(".new-pdp-prod-qty")
              .val(),
            10
          ) || 0;

        if (quantity <= 0) {
          return;
        }

        let item = {
          id: $(this).attr("data-id"),
          quantity: quantity,
          properties: {
            _mom_box_item: "true"
          }
        };

        if (
          sellingPlan &&
          sellingPlan !== "none"
        ) {
          item.selling_plan = sellingPlan;
        }

        arr.push(item);
      }
    );

    if (!arr.length) {
      $this.removeClass("active-loading");
      return;
    }

    /*
     * Repair the current Freeze Pack before checking
     * whether another one must be included.
     */
    if (
      typeof window.MOMEnforceFreezePack ===
      "function"
    ) {
      await window.MOMEnforceFreezePack();
    }

    let currentCart;

    try {
      const cartResponse = await fetch(
        "/cart.js",
        {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept: "application/json"
          },
          cache: "no-store"
        }
      );

      if (!cartResponse.ok) {
        throw new Error(
          "Cart check failed: " +
            cartResponse.status
        );
      }

      currentCart =
        await cartResponse.json();
    } catch (error) {
      console.error(
        "[MOM] Could not check the Freeze Pack:",
        error
      );

      $this.removeClass("active-loading");
      return;
    }

    /*
     * Include the Freeze Pack only when it is not
     * already in the cart.
     */
    const hasFreezePack =
      currentCart &&
      Array.isArray(currentCart.items) &&
      currentCart.items.some(function (item) {
        return (
          Number(item.variant_id) ===
          MOM_FREEZE_VARIANT_ID
        );
      });

    if (!hasFreezePack) {
      arr.unshift({
        id: MOM_FREEZE_VARIANT_ID,
        quantity: 1,
        properties: {
          _hidden: "true",
          _mom_box_freeze: "true"
        }
      });
    }

    let formData = {
      items: arr,
      sections:
        "cart-drawer,cart-icon-bubble"
    };

    fetch(
      window.Shopify.routes.root +
        "cart/add.js",
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(formData)
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (res) {
        if (
          res.status ||
          !res.sections
        ) {
          console.error(
            "[MOM] Cart add failed:",
            res
          );

          return;
        }

        /*
         * Reset the builder selections.
         */
        $(".new-pdp-box-content-wrapper").empty();

        $(".new-pdp-prod-card").removeClass(
          "active"
        );

        $(".new-pdp-prod-qty")
          .val("0")
          .text("0");

        $(".new-pdp-box-footer-price")
          .attr("data-price", "0");

        $(".new-pdp-box-footer-price strike").text(
          "$0.00"
        );

        $(".new-pdp-box-footer-price em").text(
          "$0.00"
        );

        $(".new-pdp-box-footer-price i").empty();

        $(".new-pdp-box-footer-price dl")
          .empty()
          .hide();

        $(".new-pdp-box-items-count").text(
          "0"
        );

        $(".new-box-discount")
          .removeClass("active")
          .first()
          .addClass("active");

        let firstDiscount =
          $(".new-box-discount")
            .first()
            .attr("data-discount") || "0";

        $(".new-pdp-box-footer-price")
          .attr("data-price", "0")
          .attr(
            "data-discount",
            firstDiscount
          );

        $(".new-pdp-box-footer-btn")
          .prop("disabled", true)
          .removeClass("active");

        /*
         * Refresh the drawer using Shopify's returned
         * sections.
         */
        const cartParsedData =
          new DOMParser().parseFromString(
            res.sections["cart-drawer"],
            "text/html"
          );

        const cartBubbleParsedData =
          new DOMParser().parseFromString(
            res.sections[
              "cart-icon-bubble"
            ],
            "text/html"
          );

        $("cart-drawer.drawer").removeClass(
          "is-empty"
        );

        $(".drawer__inner").html(
          $(cartParsedData)
            .find(".drawer__inner")
            .html()
        );

        $("#cart-icon-bubble").html(
          $(cartBubbleParsedData)
            .find(".shopify-section")
            .html()
        );

        /*
         * Update existing cart count immediately so
         * adding more meals activates the correct tier.
         */
        scheduleMomExistingCartMealRefresh();

        const cartBubble =
          document.querySelector(
            "#cart-icon-bubble"
          );

        if (cartBubble) {
          cartBubble.dispatchEvent(
            new Event("click")
          );
        }

        $(".cart-count-bubble").trigger(
          "click"
        );
      })
      .catch(function (error) {
        console.error(
          "[MOM] Cart add error:",
          error
        );
      })
      .finally(function () {
        $this.removeClass(
          "active-loading"
        );
      });
  }
);

$(document).on(
  "click",
  ".new-pdp-choice-mobile-wrapper span",
  function () {
    $(
      ".new-pdp-choice-mobile-wrapper span"
    ).removeClass("active");

    $(this).addClass("active");

    let id = $(this).attr("data-id");

    if (id == 1) {
      $(
        'label[for="new-pdp-my-choice"]'
      ).trigger("click");
    } else {
      $(
        'label[for="new-pdp-chef-choice"]'
      ).trigger("click");
    }
  }
);

$(document).on(
  "change",
  ".new-pdp-mobile-sp-inp",
  function () {
    $(".new-pdp-box-footer-btn").attr(
      "data-selling-plan",
      $(this).val()
    );

    $(this)
      .parents(".new-pdp")
      .find(
        ".page-width > .new-pdp-mobile-sp-wrapper"
      )
      .find(".new-pdp-mobile-sp-inp")
      .removeClass("active");

    $(this)
      .parents(".new-pdp")
      .find(
        ".page-width > .new-pdp-mobile-sp-wrapper"
      )
      .find(
        `.new-pdp-mobile-sp-inp[value="${$(this).val()}"]`
      )
      .addClass("active");
  }
);

$(document).on(
  "click",
  ".cc__columnitemcontainer-item-link",
  function (event) {
    if ($(window).width() <= 480) {
      event.preventDefault();

      $(
        ".cc__columnitemcontainer-item-link"
      ).removeClass("new-act");

      $(this).addClass("new-act");

      $(".new-stick-multi-btn").removeClass(
        "inactive"
      );

      $(".new-stick-multi-btn span").text(
        $(this).attr("data-title")
      );
    }
  }
);

$(document).on(
  "click",
  ".new-stick-multi-btn",
  function () {
    location.href = $(
      ".cc__columnitemcontainer-item-link.new-act"
    ).attr("href");
  }
);

function debounce(fn, delay) {
  let timer;

  return function (...args) {
    clearTimeout(timer);

    timer = setTimeout(
      () => fn.apply(this, args),
      delay
    );
  };
}

$(document).on(
  "input",
  ".new-blog-search-inp",
  debounce(function () {
    let query = $(this).val().trim();

    if (query.length > 0) {
      $(".new-blog-right").hide();

      $(".new-blog-right-search-results")
        .addClass("active")
        .addClass("new-load")
        .empty();

      $.ajax({
        type: "GET",
        url:
          "/search?q=" +
          encodeURIComponent(query) +
          "&view=ajax",

        success: function (result) {
          $(".new-blog-right-search-results")
            .html(result)
            .removeClass("new-load");
        }
      });
    } else {
      $(".new-blog-right-search-results")
        .removeClass("active")
        .empty();

      $(".new-blog-right").show();
    }
  }, 500)
);

$(document).on(
  "change",
  ".new-blog-menu-select",
  function () {
    let url = $(this)
      .find("option:selected")
      .attr("data-url");

    if (url) {
      window.location.href = url;
    }
  }
);

/*
 * ZIP submission.
 *
 * Every valid ZIP submission clears the existing cart
 * before switching Local/Nationwide ordering mode.
 */
$(document).on(
  "click",
  ".new-hero-zip-btn",
  async function (event) {
    event.preventDefault();

    const $button = $(this);

    const zip = $button
      .parent()
      .find(".new-hero-zip-input")
      .val()
      .trim();

    const localZips = [
      89431,
      89433,
      89434,
      89436,
      89441,
      89501,
      89502,
      89521,
      89439,
      89503,
      89506,
      89508,
      89509,
      89511,
      89512,
      89519,
      89523
    ];

    if (!/^\d{5}$/.test(zip)) {
      alert(
        "Please enter a valid 5-digit ZIP code."
      );

      return;
    }

    const isLocal = localZips.includes(
      parseInt(zip, 10)
    );

    const redirectFromPdp =
      window.location.search.indexOf(
        "redirect-from-pdp"
      ) !== -1;

    let destination;

    if (redirectFromPdp) {
      destination = isLocal
        ? "/products/60-pack"
        : "/products/60-pack-nation-wide";
    } else {
      destination =
        "/collections/build-a-box?new-hero-redirect=yes";
    }

    const originalButtonText =
      $button.text();

    $button
      .prop("disabled", true)
      .text("PLEASE WAIT...");

    try {
      const clearResponse = await fetch(
        "/cart/clear.js",
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type":
              "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({})
        }
      );

      if (!clearResponse.ok) {
        throw new Error(
          "Cart clear failed: " +
            clearResponse.status
        );
      }

      const expiry =
        parseInt(
          document.body.getAttribute(
            "data-expire"
          ),
          10
        ) || 1;

      Cookies.set(
        "buildabox_zip",
        zip,
        {
          expires: expiry
        }
      );

      window.location.href = destination;
    } catch (error) {
      console.error(
        "[MOM] ZIP cart reset failed:",
        error
      );

      $button
        .prop("disabled", false)
        .text(originalButtonText);

      alert(
        "The cart could not be cleared. Please try again."
      );
    }
  }
);

/* =========================================
   NEW MULTI-SELECT PRODUCT FILTERS
========================================= */

function updateNewBoxFilters($module) {
  let scope = $module.attr(
    "data-filter-scope"
  );

  let $grid = $(
    '.new-pdp-products-wrapper[data-filter-grid="' +
      scope +
      '"]'
  );

  let $cards = $grid.find(
    ".new-pdp-prod-card"
  );

  let activeGroups = [];

  /*
   * Same filter group uses OR.
   * Different groups use AND.
   */
  $module
    .find(".new-box-filter-group")
    .each(function () {
      let groupValues = [];

      $(this)
        .find(
          ".new-box-filter-option.applied"
        )
        .each(function () {
          let value = String(
            $(this).attr("data-value") ||
              ""
          )
            .trim()
            .toLowerCase();

          if (value) {
            groupValues.push(value);
          }
        });

      if (groupValues.length > 0) {
        activeGroups.push(groupValues);
      }
    });

  let visibleCount = 0;

  $cards.each(function () {
    let $card = $(this);

    let tags = String(
      $card.attr("data-tags") || ""
    )
      .split(",")
      .map(function (tag) {
        return tag
          .trim()
          .toLowerCase();
      })
      .filter(Boolean);

    let isMatch = activeGroups.every(
      function (groupValues) {
        return groupValues.some(
          function (filterValue) {
            return (
              tags.indexOf(
                filterValue
              ) !== -1
            );
          }
        );
      }
    );

    $card.toggle(isMatch);

    if (isMatch) {
      visibleCount++;
    }
  });

  $module
    .find(".new-box-filter-meals-count")
    .text(
      visibleCount +
        (visibleCount === 1
          ? " meal"
          : " meals")
    );

  let selectedCount = $module.find(
    ".new-box-filter-option.applied"
  ).length;

  if (selectedCount > 0) {
    $module
      .find(
        ".new-box-filter-open-count"
      )
      .text(
        "(" + selectedCount + ")"
      );

    $module.addClass(
      "has-active-filters"
    );
  } else {
    $module
      .find(
        ".new-box-filter-open-count"
      )
      .text("");

    $module.removeClass(
      "has-active-filters"
    );
  }

  let $selectedWrapper =
    $module.find(
      ".new-box-filter-selected"
    );

  $selectedWrapper.empty();

  $module
    .find(
      ".new-box-filter-option.applied"
    )
    .each(function () {
      let $option = $(this);
      let label =
        $option.attr("data-label");
      let value =
        $option.attr("data-value");

      let group = $option
        .closest(
          ".new-box-filter-group"
        )
        .attr("data-filter-group");

      let $chip = $("<button>", {
        type: "button",
        class:
          "new-box-selected-filter"
      });

      $chip.text(label + " ×");

      $chip.attr({
        "data-value": value,
        "data-group": group
      });

      $selectedWrapper.append(
        $chip
      );
    });
}

$(document).on(
  "click",
  ".new-box-filter-option",
  function (event) {
    event.preventDefault();

    let $option = $(this);

    $option.toggleClass("active");

    $option.attr(
      "aria-pressed",
      $option.hasClass("active")
        ? "true"
        : "false"
    );
  }
);

function restorePendingFilters($module) {
  $module
    .find(".new-box-filter-option")
    .removeClass("active")
    .attr("aria-pressed", "false");

  $module
    .find(
      ".new-box-filter-option.applied"
    )
    .addClass("active")
    .attr("aria-pressed", "true");
}

$(document).on(
  "click",
  ".new-box-filter-open",
  function (event) {
    event.preventDefault();

    let $module = $(this).closest(
      ".new-box-filter-module"
    );

    $(
      ".new-box-filter-module.filter-open"
    )
      .not($module)
      .each(function () {
        let $otherModule = $(this);

        restorePendingFilters(
          $otherModule
        );

        $otherModule.removeClass(
          "filter-open"
        );
      });

    restorePendingFilters($module);

    $module.addClass("filter-open");

    $("body").addClass(
      "new-box-filter-body-open"
    );
  }
);

function closeNewBoxFilter(
  $module,
  restoreSelections = true
) {
  if (restoreSelections) {
    restorePendingFilters($module);
  }

  $module.removeClass("filter-open");

  if (
    $(
      ".new-box-filter-module.filter-open"
    ).length === 0
  ) {
    $("body").removeClass(
      "new-box-filter-body-open"
    );
  }
}

$(document).on(
  "click.newBoxFilterOutside",
  function (event) {
    $(
      ".new-box-filter-module.filter-open"
    ).each(function () {
      let $module = $(this);

      if (
        $(event.target).closest(
          ".new-box-filter-drawer"
        ).length
      ) {
        return;
      }

      if (
        $(event.target).closest(
          ".new-box-filter-open"
        ).length
      ) {
        return;
      }

      closeNewBoxFilter(
        $module,
        true
      );
    });
  }
);

$(document).on(
  "click",
  ".new-box-filter-close",
  function (event) {
    event.preventDefault();

    let $module = $(this).closest(
      ".new-box-filter-module"
    );

    closeNewBoxFilter(
      $module,
      true
    );
  }
);

$(document).on(
  "click",
  ".new-box-filter-overlay",
  function (event) {
    event.preventDefault();

    let $module = $(this).closest(
      ".new-box-filter-module"
    );

    closeNewBoxFilter(
      $module,
      true
    );
  }
);

$(document).on(
  "click",
  ".new-box-filter-apply",
  function (event) {
    event.preventDefault();

    let $module = $(this).closest(
      ".new-box-filter-module"
    );

    $module
      .find(".new-box-filter-option")
      .removeClass("applied");

    $module
      .find(
        ".new-box-filter-option.active"
      )
      .addClass("applied");

    updateNewBoxFilters($module);

    closeNewBoxFilter(
      $module,
      false
    );
  }
);

$(document).on(
  "click",
  ".new-box-filter-reset",
  function (event) {
    event.preventDefault();

    let $module = $(this).closest(
      ".new-box-filter-module"
    );

    $module
      .find(".new-box-filter-option")
      .removeClass(
        "active applied"
      )
      .attr(
        "aria-pressed",
        "false"
      );

    updateNewBoxFilters($module);
  }
);

$(document).on(
  "click",
  ".new-box-filter-clear-all",
  function (event) {
    event.preventDefault();

    let $module = $(this).closest(
      ".new-box-filter-module"
    );

    $module
      .find(".new-box-filter-option")
      .removeClass(
        "active applied"
      )
      .attr(
        "aria-pressed",
        "false"
      );

    updateNewBoxFilters($module);
  }
);

$(document).on(
  "click",
  ".new-box-selected-filter",
  function (event) {
    event.preventDefault();

    let $chip = $(this);

    let $module = $chip.closest(
      ".new-box-filter-module"
    );

    let value =
      $chip.attr("data-value");

    let group =
      $chip.attr("data-group");

    $module
      .find(
        '.new-box-filter-group[data-filter-group="' +
          group +
          '"] .new-box-filter-option'
      )
      .filter(function () {
        return (
          $(this).attr(
            "data-value"
          ) === value
        );
      })
      .removeClass(
        "active applied"
      )
      .attr(
        "aria-pressed",
        "false"
      );

    updateNewBoxFilters($module);
  }
);

$(document).on(
  "keydown",
  function (event) {
    if (event.key !== "Escape") {
      return;
    }

    $(
      ".new-box-filter-module.filter-open"
    ).each(function () {
      closeNewBoxFilter(
        $(this),
        true
      );
    });
  }
);

function initNewBoxFilters() {
  $(".new-box-filter-module").each(
    function () {
      updateNewBoxFilters(
        $(this)
      );
    }
  );
}

$(function () {
  initNewBoxFilters();
});